import { Link } from "react-router-dom";
import { PageHero } from "../components/PageShell";
import { ROUTES } from "../lib/routes";
import { COMMITTEES } from "../lib/committees";

export default function Compliance() {
  return (
    <>
      <PageHero
        variant="hero-navy"
        eyebrow="Statutory committees"
        title="A safe campus is a non-negotiable. Here's how we keep it that way."
        lead="BIET maintains six statutory committees mandated by UGC, AICTE and the POSH Act. Every committee has clearly named members, public contact details, and a confidential reporting channel. Reports are reviewed every quarter by the Director's office."
        crumbs={[{ label: "About", to: ROUTES.about }, { label: "Compliance" }]}
        image={null}
      />
      <section className="section">
        <div className="container">
          <div className="report-card">
            <div>
              <h3>Need to report something? You can do it anonymously.</h3>
              <p>Report ragging, harassment, discrimination or any grievance. All reports are confidential and reviewed within 24 hours.</p>
            </div>
            <div className="actions">
              <span className="hot">24×7 ANTI-RAGGING HOTLINE</span>
              <span className="num">1800-180-5522</span>
              <Link className="btn-link" to={ROUTES.reportConcern} style={{ color: "var(--gold-400)", borderBottomColor: "var(--gold-400)" }}>File a confidential report →</Link>
            </div>
          </div>

          <h2 style={{ marginTop: 80, fontSize: "clamp(28px, 3vw, 40px)", fontWeight: 600 }}>Statutory committees</h2>
          <p style={{ color: "var(--text-soft)", marginTop: 8, fontSize: 17, maxWidth: "60ch" }}>Each committee has a designated chairperson, convener and contact email. Constitution refreshed annually.</p>
          <div className="committee-grid">
            {COMMITTEES.map((c) => (
              <Link key={c.slug} to={`${ROUTES.committees}/${c.slug}`} className="committee-card reveal" style={{ display: "block", textDecoration: "none", color: "inherit" }}>
                <h3>{c.name}</h3>
                <p className="purpose">{c.purpose}</p>
                <dl>
                  <dt>Chair</dt><dd>{c.chair}</dd>
                  <dt>Convener</dt><dd>{c.convener}</dd>
                  <dt>Email</dt><dd><span style={{ color: "var(--accent-strong)" }}>{c.contact.email}</span></dd>
                  <dt>Phone</dt><dd>{c.contact.phone}</dd>
                </dl>
                <div className="members"><b>Membership:</b> {c.members}</div>
              </Link>
            ))}
          </div>

          <h2 style={{ marginTop: 80, fontSize: "clamp(28px, 3vw, 40px)", fontWeight: 600 }}>Affidavits & online filings</h2>
          <p style={{ color: "var(--text-soft)", marginTop: 8, fontSize: 16, lineHeight: 1.65, maxWidth: "65ch" }}>
            Every fresh student and parent must file an anti-ragging affidavit at the start of each academic year, as mandated by UGC Regulations 2009. Forms are also available with the admissions office.
          </p>
          <div className="disc-list" style={{ marginTop: 24 }}>
            <a className="disc-item" href="#"><div className="disc-icon">PDF</div><div className="disc-info"><div className="name">Student anti-ragging affidavit</div><div className="meta">UGC FORMAT · 2 PAGES</div></div><span className="disc-action">Download →</span></a>
            <a className="disc-item" href="#"><div className="disc-icon">PDF</div><div className="disc-info"><div className="name">Parent anti-ragging affidavit</div><div className="meta">UGC FORMAT · 2 PAGES</div></div><span className="disc-action">Download →</span></a>
            <a className="disc-item" href="#"><div className="disc-icon">↗</div><div className="disc-info"><div className="name">UGC online affidavit portal</div><div className="meta">EXTERNAL · ANTIRAGGING.IN</div></div><span className="disc-action">Visit →</span></a>
            <a className="disc-item" href="#"><div className="disc-icon">↗</div><div className="disc-info"><div className="name">National Anti-Ragging Helpline</div><div className="meta">UGC HELPLINE · 1800-180-5522</div></div><span className="disc-action">Call →</span></a>
          </div>
        </div>
      </section>
    </>
  );
}
